import { type SupportedIcon } from 'corso-admin-ui';

export type StoreSection = {
  label: string;
  to: string;
  icon: SupportedIcon;
  activeIcon?: SupportedIcon;
};

// LOCAL: section list mirrors what the Implementation Actions Retool app
// surfaces today (Store Info, Subscription/Billing/Invoices grouped as
// "Plan & billing", Pricing Set, Widget Settings, Commission, Online +
// Fulfillment Locations, Shipping Lines, Store Contacts, Agency, Custom
// Dashboards, Onboarding Steps, Store Access, Support SLA). Anything not
// in Retool today (e.g. "Feature toggles" / standalone "Fulfillment") was
// dropped so the nav matches reality.
export const storeSections = [
  {
    label: 'Store info',
    to: 'info',
    icon: 'store',
    activeIcon: 'storeSolid',
  },
  {
    label: 'Support SLA',
    to: 'support-sla',
    icon: 'help',
    activeIcon: 'helpSolid',
  },
  {
    label: 'Onboarding',
    to: 'onboarding',
    icon: 'registration',
    activeIcon: 'registrationSolid',
  },
  {
    label: 'Billing',
    to: 'billing',
    icon: 'dollar',
    activeIcon: 'dollarSolid',
  },
  {
    label: 'Pricing set',
    to: 'pricing-set',
    icon: 'tag',
    activeIcon: 'tagsSolid',
  },
  { label: 'Users', to: 'users', icon: 'users', activeIcon: 'usersSolid' },

  {
    label: 'Platform',
    to: 'platform',
    icon: 'settings',
    activeIcon: 'settingsSolid',
  },
  {
    label: 'Shipping protection',
    to: 'shipping-protection',
    icon: 'plugins',
    activeIcon: 'pluginsSolid',
  },
] satisfies StoreSection[];
